/**
 * webhooks-crud
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
export enum LogSeverity {
  INFO = 'INFO',
  ERROR = 'ERROR',
}

export interface StepLog {
  /**
   * The log message
   */
  message?: string;
  /**
   * The severity of the log
   */
  severity?: LogSeverity;
  /**
   * The ID of the step
   */
  step_id?: string;
  /**
   * The ID of the playbook
   */
  playbook_id?: string;
  /**
   * The ID of the trigger
   */
  trigger_id?: string;
  /**
   * timestamp of the step execution
   */
  timestamp?: string;
  /**
   * The round of this trigger (in case of retry)
   */
  action_round?: number;
}
